export const theme = {
  colors: {
    neutralGray: '#64748B',
    primary: '#ec78b8',
    primary2: '#7F51B2',

    secondary: '#64748B',
    secondary2: '#CBD5E1',
    secondary3: '#334155',

    background: '#a39485',
    brown: '#b9a998',
    black: '#242424',
    blue: '#00BAB2',
    white: '#ffffff',
    offWhite: '#f6ede4',
    default: '#FAFAFA',
    error: '#D12C38',
    success: '#2DAC3E',
  },
} as const;
// src/theme.ts
export const lightTheme = {
  colors: {
    neutralGray: '#64748B',
    primary: '#ec78b8',
    primary2: '#7F51B2',
    purple: '#c88aff',
    orange: '#ea9f31',
    yellow: '#ffa966',
    ciano: '#8de0d8',

    secondary: '#64748B',
    secondary2: '#CBD5E1',
    secondary3: '#334155',

    background: '#f6ede4',
    background2: '#fff',
    brown: '#b9a998',
    text: '#242424',
    text2: '#545454',
    blue: '#00BAB2',
    white: '#ffffff',
    offWhite: '#f6ede4',
    default: '#FAFAFA',
    error: '#D12C38',
    success: '#2DAC3E',
  },
};

export const darkTheme = {
  colors: {
    neutralGray: '#64748B',
    primary: '#ec78b8',
    primary2: '#7F51B2',
    purple: '#c88aff',
    orange: '#ea9f31',
    yellow: '#ffa966',
    ciano: '#8de0d8',

    secondary: '#64748B',
    secondary2: '#CBD5E1',
    secondary3: '#334155',

    background: '#121212',
    background2: '#292a2d',
    brown: '#b9a998',
    black: '#242424',
    blue: '#00BAB2',
    text: '#ffffff',
    text2: '#c08a97',
    offWhite: '#f6ede4',
    default: '#FAFAFA',
    error: '#D12C38',
    success: '#2DAC3E',
  },
  fonts: {
    main: "'Inter', sans-serif",
  },
};
